<ng-container *ngIf="metadata">
    <div  class="eac-display-4 section-name d-flex align-items-center ">{{metadata.name}}</div>
    <div *ngFor="let item of metadata.items">

        @if (isVisible(item)) {

            @switch (item.type) {

                @case ('ROW_LAYOUT') {
                    <app-dynamic-view-row-layout [layout]="item" [value]="modelData" [fieldVisibility]="fieldVisibility">

                    </app-dynamic-view-row-layout>
                }

                @case ('REPEAT_LAYOUT') {
                    <app-dynamic-view-repeat-layout [layout]="item" [value]="modelData">

                    </app-dynamic-view-repeat-layout>
                }

                @case ('WEBSERVICE_LAYOUT') {
                    <app-dynamic-view-webservice-layout [layout]="item" [value]="modelData">

                    </app-dynamic-view-webservice-layout>
                }

            }

        }

    </div>
</ng-container>
